export default  [
  {
    key: "owner",
    label: "Owner",
    sortable: true
  },

  {
    key: "contract",
    label: "Contract",
    sortable: true
  },
  {
    key: "plan",
    label: "Plan",
    sortable: true
  },

  {
    key: "device",
    label: "Device",
    sortable: true
  },


  {
    key: "area",
    label: "Area",
    sortable: true
  },


  {
    key: "date",
    label: "Date",
    sortable: true
  },

  {
    key: "day",
    label: "Day",
    sortable: true
  },

  {
    key: "shift_start",
    label: "start",
    sortable: true
  },

  {
    key: "shift_end",
    label: "end",
    sortable: true
  },

  {
    key: "first_wash",
    label: "First Wash",
    sortable: true
  },

  {
    key: "last_wash",
    label: "Last Wash",
    sortable: true
  },

  {
    key: "total_distance",
    label: "total distance",
    sortable: true
  },

  {
    key: "distance_inside",
    label: "distance inside route",
    sortable: true
  },

  {
    key: "distance_out",
    label: "distance out route",
    sortable: true
  },

  {
    key: "planned",
    label: "planned",
    sortable: true
  },

  {
    key: "wash_count_out",
    label: "out work area",
    sortable: true
  },

  {
    key: "wash_count_inside",
    label: "inside work area",
    sortable: true
  },

  {
    key: "total_washed",
    label: "total achieved",
    sortable: true
  },

  {
    key: "percent",
    label: "percent",
    sortable: true
  },

  {
    key: 'action',
    label: 'Action'
  }

]